// removed by extract-text-webpack-plugin
module.exports = {"blurred":"PastMeetingsTab-blurred"};